<template>
  <div>
    
    <vs-button @click.stop="printData()" icon-pack="feather" icon="icon-printer" class="">Cetak</vs-button>
    
    <!-- Soft -->
    <div class="text-center mb-10">
      <h3>Pelaksanaan</h3>
      <h3>{{pelaksanaan.task_title}}</h3>
      <h3>Per Tanggal</h3>
    </div>
    <vs-divider></vs-divider>
    <div class="vx-row">
      <div class="vx-col flex flex-2"> <b>No.</b> </div>

      <div class="vx-col w-1/4"> <b>Biaya</b> </div>

      <div class="vx-col flex flex-1"> <b>Satuan</b> </div>
      
      <div class="vx-col flex flex-1"> <b>Harga Satuan</b> </div>
      
      <div class="vx-col flex flex-1"> <b>@</b> </div>
      
      <div class="vx-col w-1/6"> <b>Jumlah</b> </div>
    </div>
    <vs-divider></vs-divider>
    <div class="vx-row" v-for="(data, index) in tasks" :key="index">
        
        <div class="vx-col flex flex-2"><p class="product-name font-medium truncate"> {{index+1}}. </p></div>

        <div class="vx-col w-1/4"> {{ data.title }} </div>

        <div class="vx-col flex flex-1"> {{ data.unit }} </div>
        
        <div class="vx-col flex flex-1"> 
          <div v-if="data.price != 0">
            {{ data.price | currency  }}
          </div>
          <div v-else>
            -
          </div>
        </div>

        <div class="vx-col flex flex-1"> 
          <div v-if="data.quantity != 0">
            {{ data.quantity  }}
          </div>
          <div v-else>
            -
          </div>
        </div>
        
        <div class="vx-col w-1/6"> {{ data.total | currency }} </div>
        <vs-divider></vs-divider>
    </div>
    <!-- / Soft -->

    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :htmlToPdfOptions="htmlToPdfOptions"
      :paginate-elements-by-height="1200"
      filename="V"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @progress="onProgress($event)"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2Pdf"
      >
      <!-- :htmlToPdfOptions="htmlToPdfOptions" -->
      <section slot="pdf-content" class="px-10">
        <section class="pdf-item px-10">
          <div class="text-center mb-10">
            <h4>Pelaksanaan</h4>
            <h4>{{pelaksanaan.task_title}}</h4>
            <h4>Per Tanggal</h4>
          </div>
          <vs-divider></vs-divider>
          <div style="font-size:10px;" class="vx-row">
            <div class="vx-col flex flex-2"> <b>No.</b> </div>

            <div class="vx-col w-1/4"> <b>Biaya</b> </div>

            <div class="vx-col flex flex-1"> <b>Satuan</b> </div>
            
            <div class="vx-col flex flex-1"> <b>Harga Satuan</b> </div>
            
            <div class="vx-col flex flex-1"> <b>@</b> </div>
            
            <div class="vx-col w-1/6"> <b>Jumlah</b> </div>
          </div>
          <vs-divider></vs-divider>
          <div style="font-size:10px;" class="vx-row" v-for="(data, index) in tasks" :key="index">
              
              <div class="vx-col flex flex-2"><p class="font-medium"> {{index+1}}. </p></div>

              <div class="vx-col w-1/4"> {{ data.title }} </div>

              <div class="vx-col flex flex-1"> {{ data.unit }} </div>
        
              <div class="vx-col flex flex-1"> 
                <div v-if="data.price != 0">
                  {{ data.price | currency  }}
                </div>
                <div v-else>
                  -
                </div>
              </div>

              <div class="vx-col flex flex-1"> 
                <div v-if="data.quantity != 0">
                  {{ data.quantity  }}
                </div>
                <div v-else>
                  -
                </div>
              </div>
              
              <div class="vx-col w-1/6"> {{ data.total | currency }} </div>
              <vs-divider></vs-divider>
          </div>
        </section>
      </section>
    </vue-html2pdf>

    <div class="pro-vs-loading px-12" v-if="onPro">
      <vs-progress :percent="onPercent" color="primary" class="mx-8">primary</vs-progress>
    </div>
    
  </div>
</template>
<script>
import moduleProgress from '@/stores/proyek/progress/moduleProgress.js'
import VueHtml2pdf from 'vue-html2pdf'
export default {
  components: {
    VueHtml2pdf
  },
  data() {
    return {
      wasSidebarOpen: true,
      onPercent: 2,
      onPro: false,
      htmlToPdfOptions: {
        margin: [10,0,10,0],
        image: {
          type: 'jpeg', 
          quality: 0.98
        },
        html2canvas: {
          scale: 5,
          useCORS: true
        },
        pagebreak: { mode: 'avoid-all', after: '.avoidThisRow' }
      }
    };
  },
  computed: {
    tasks () {
      return this.$store.state.pekerjaan.biaya
    },
    pelaksanaan () {
      return this.$store.state.pekerjaan.pelaksanaan
    },
  },
  methods: {
    onProgress (event) {
      this.onPro = true
      this.onPercent = event
      if (event === 100) {
        this.onPro = false
        this.onPercent = 2
      }
    },
    printData () {
      this.$refs.html2Pdf.generatePdf()
    }
  },
  created () {
    this.$store.registerModule('pekerjaan', moduleProgress)
    this.$vs.loading()
    this.$store.dispatch('pekerjaan/fetchBiaya', this.$route.params.id)
    setTimeout(() => {
      this.$vs.loading.close()
    }, 4000)
  },
  mounted () {
    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)
    window.onpopstate = event => {
      this.$vs.notify({
        title: 'Back',
        text  : event,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success'
      })
      if (this.wasSidebarOpen === true) {
        this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
      }
    };
  },
  beforeDestroy () {
    this.$store.unregisterModule('pekerjaan')
    //if (this.wasSidebarOpen === true) { 
      this.$store.commit('TOGGLE_REDUCE_BUTTON', false)
    //}
  }
};
</script>
<style lang="scss">
  .cetak {
    table, th {
      border: 1px solid black;
      border-collapse: collapse;
    }
    td {
      padding-left: 4px;
      border-top: 1px solid black;
      border-right: 1px solid black;
      border-collapse: collapse;
    }
  }
</style>